import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  SharedModule,
  FormInputComponent,
  NotificationService,
  StringCustomFieldConfig,
} from '@vendure/admin-ui/core';
import { safeJSONParse } from '../../common/ui/utils';

interface PromotionalTier { min: number; max?: number | null; discount: number; }

@Component({
  selector: 'min-max-discount-form-input',
  template: `
    <vdr-card class="m-0 p-0">
      <div class="flex gap-4">
        <vdr-form-field label="Min" class="mr-4">
            <vdr-dynamic-form-input
                [control]="minControl"
                [def]="{
                    type: 'int',
                    ui: {
                        component: 'number-form-input',
                        min: '0',

                    }
                }"
            >
            </vdr-dynamic-form-input>
        </vdr-form-field>
        <vdr-form-field label="Max" class="mr-4">
            <vdr-dynamic-form-input
                [control]="maxControl"
                [def]="{
                    type: 'int',
                    ui: {
                        component: 'number-form-input',
                        min: '0',
                    }
                }"
            >
            </vdr-dynamic-form-input>
        </vdr-form-field>
        <vdr-form-field label="Discount">
            <vdr-dynamic-form-input
                [control]="discountControl"
                [def]="{
                    type: 'int',
                    ui: {
                        component: 'number-form-input',
                        suffix: '%',
                        min: '0',
                        max: '100',
                    }
                }"
            >
            </vdr-dynamic-form-input>
        </vdr-form-field>
      </div>
    </vdr-card>
  `,
  standalone: true,
  imports: [SharedModule],
})
export class MinMaxDiscountFormInputComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  readonly: boolean;
  config: StringCustomFieldConfig;
  formControl: FormControl;

  minControl = new FormControl<number>(0, {validators: [Validators.required, Validators.min(0)]});
  maxControl = new FormControl<number | null>(null, {validators: [Validators.min(0)]});
  discountControl = new FormControl<number>(0, {validators: [Validators.required, Validators.min(0), Validators.max(100)]});

  private data: PromotionalTier;

  constructor(
    private notify: NotificationService
  ) {}

  ngOnInit() {
    const defaultData: PromotionalTier = { min: 0, max: null, discount: 0 };
    this.data = safeJSONParse<PromotionalTier>(
      this.formControl.value || '{}',
      this.notify,
      defaultData,
    )!;

    this.minControl.setValue(this.data.min);
    this.maxControl.setValue(this.data.max ?? null);
    this.discountControl.setValue(this.data.discount);

    [this.minControl, this.maxControl, this.discountControl].forEach(ctrl =>
      ctrl.valueChanges.subscribe(this.update),
    );
  }

  private update = () => {
    this.data = {
      min: this.minControl.value ?? 0,
      max: this.maxControl.value,
      discount: this.discountControl.value ?? 0,
    };
    this.formControl.setValue(JSON.stringify(this.data));
    this.formControl.markAsDirty();
  };
}
